import { pgMessageBox } from '../../message-box/index'
import { Loading } from 'element-ui'
import { http, clone, setValueByPath } from '../../../utils/index'

export async function requset({ property, parameter }, actions) {
  const {
    form = false, //是否整单提交
    parameterKey, // 在form为false时且parameterKey有值生效， 将parameter中的parameterKey对应的值作为请求参数
    confirm, // 是否需要弹窗
    confirmOption, // 请求弹窗相关选项
    method = 'post', // 请求方式
    url, //  请求接口
    successTip, // 请求接口成功后是否需要提示
    successtop, // 请求接口成功后是否将返回信息提示在顶部
    forceSubmit, //是否强制提交，会自动设置，不要配置该字段
    forceSubmitConfirmOption,
    loading = true, //是否显示loading
    successMethod, //支持请求成功后执行一个方法，如保存成功后将返回数据更新到表单等
    clearTops = true, //是否清空顶部的提示信息
  } = property

  const messageBoxRes = await new Promise((resolve) => {
    if (confirm) {
      pgMessageBox({
        ...confirmOption,
        beforeClose: (done, type) => {
          resolve({ done, type })
        },
      })
    } else {
      resolve({ type: 'confirm' })
    }
  })
  messageBoxRes.done?.()

  if (messageBoxRes.type === 'confirm') {
    if (clearTops) {
      actions.updateTopErrors?.({ errors: [] })
      actions.updateSuccess?.({ data: [] })
    }

    const copyParameter = clone(parameter)
    const params = form
      ? actions.getAllFormData?.() ?? copyParameter
      : parameterKey
      ? copyParameter[parameterKey]
      : copyParameter
    const { expandFields, ...optional } = copyParameter
    //支持整单提交时添加额或修改属性
    if (form && expandFields && params !== copyParameter) {
      const fields = Object.keys(expandFields)
      for (const key of fields) {
        setValueByPath(params, key, expandFields[key])
      }
    }
    //整单提交时其他参数添加到optional
    if (form && Object.keys(optional ?? {}).length > 0 && params !== copyParameter) {
      params.optional = optional
    }
    if (forceSubmit) {
      params.forceSubmit = true
    }
    if (!url) {
      return Promise.reject({ msg: '未配置请求地址' })
    }
    const loadingInstance = loading
      ? Loading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
      : null
    const [res, error] = await http[method](url, params, { errorTip: null, successTip: successTip })
    loadingInstance?.close()
    if (error?.errors?.length > 0) {
      actions.updateTopErrors?.(error)
    }
    if (res) {
      if (res.errors?.length > 0) {
        actions.updateTopErrors?.(res)
      }
      if (successtop && res?.data?.length > 0) {
        actions.updateTopSuccess?.(res)
      }
      if (successMethod) {
        await actions[successMethod](res)
      }
      return Promise.resolve(res)
    } else if (
      error?.code === 400 &&
      error.errors?.length > 0 &&
      !error.errors.some((im) => im.level === 1)
    ) {
      //触发强制提交
      const forceProperty = {
        ...property,
        confirm: true,
        confirmOption: {
          message: error.msg ?? '确认强制提交',
          cacelText: '',
          secoundConfirmText: '查看问题',
          confirmText: '继续提交',
          ...forceSubmitConfirmOption,
        },
        forceSubmit: true,
      }
      return requset({ property: forceProperty, parameter }, actions)
    } else {
      return Promise.reject(error)
    }
  } else {
    return Promise.reject()
  }
}
